import type Result from './Result'

import { LoadedDynamicCommand } from '../../../Foobara/Commandforge/Types/DynamicCommand/Loaded'

export default function castJsonResult (json: any): Result {
  json = new LoadedDynamicCommand(json)
  return json
}
